import { IOrderElement } from './../model/types'

const calcTotalSum = (
  array: IOrderElement[],
  diffCheck: boolean,
  selectedSum: number,
  prepayment: boolean
): number => {
  if (array.length) {
    const selectedEl: boolean = array.some((i: IOrderElement): boolean => i.selected)
    if (diffCheck || (!diffCheck && selectedEl)) {
      return selectedSum
    }
    const result: number = array.reduce((sum: number, element: IOrderElement): number => {
      const price: number = prepayment ? element.price : element.finalPrice
      const selectedElement: number =
        !element.selected_guest_id && element.status === 'NOT_PAID'
          ? price
          : 0
      return sum + selectedElement / 100
    }, 0)

    return result > 0 ? result : 0
  }
  return 0
}

export default calcTotalSum
